module.exports = __webpack_public_path__ + "img/accountsettings.c13cf3fa.svg";